import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useFetchDetails from '../hooks/Clinic/useFetchClinicianDetails';
import ClinicianAdminDetails from '../components/clinician/ClinicianAdminDetails';
import { DashboardLayout } from '../layouts/DashboardLayout';
import Breadcrumb from '../components/Breadcrumbs';
const ClinicianDetailPage: React.FC = () => {
  
    const {id} = useParams();
    const { selectedClinician, isLoading, error, fetchClinicianData } = useFetchDetails();
  
    useEffect(() => {
      if (id) {
        fetchClinicianData(id);
      }
    }, [id, fetchClinicianData]);

    return (
        <>

          <DashboardLayout>
              <Breadcrumb items={[
                { label: 'Home', href: '/' },
                { label: 'Clinicians', href: '/practice/clinicians' },
                { label: selectedClinician?.name || 'Clinician Details', active: true },
              ]} />
              {selectedClinician && <ClinicianAdminDetails clinician={selectedClinician}  isLoading={isLoading} />}
            </DashboardLayout>
        </>
    );
}

export default ClinicianDetailPage